import React from 'react';
import { Reveal } from './Reveal';
const audiences = ['Reiki Practitioners Building Their Practice', 'Energy Workers Seeking Professional Structure', 'Therapists & Coaches Adding Energy Work', 'Spiritual Entrepreneurs Starting Out', 'Anyone Ready to Monetize Their Healing Gifts', 'Practitioners Wanting to Train Others'];
export function ProfessionalAudience() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-195" data-mp="724ywv1tbz0m">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-196" data-mp="73pv0p3rzq0l">
        <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-197" data-mp="bznbcvf1gwdd">
          ⚡ Designed for Practitioners Ready to{' '}
          <span className="text-sage" data-id="element-198" data-mp="g338dsv0syql">Go Professional</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-199" data-mp="l03c3x4edpej">
          If you want to work with energy but don't know how to structure your practice, create
          professional sessions, or charge what you're worth — this system was built for you.
        </p>
        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-200" data-mp="1a2javaazyjn6">
          {audiences.map(audience => <li key={audience} className="rounded-full border border-amber/50 bg-surface px-4 py-2.5 text-sm font-semibold text-navy shadow-premium" data-id="element-201" data-mp="15984tbe0e6wb">
              ✅ {audience}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}